module.exports = __webpack_public_path__ + "img/wein-wellness.cde488c6.jpg";